// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".plan-header__title[data-v-961b50b2]{font-size:28px;font-weight:700;line-height:1.2;color:#6b45d7}.ui-dark .plan-header__title[data-v-961b50b2]{color:#a082f4}.plan-header__subtitle[data-v-961b50b2]{margin-top:6px;font-size:1.125rem;font-weight:400}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
